import { aboutInfo } from '@/mocks/siteData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">了解51电影网背后的故事与使命</p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-2xl p-6 md:p-10">
          <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-6">
            {aboutInfo.title}
          </h3>

          <div className="space-y-4 mb-10">
            {aboutInfo.paragraphs.map((p, i) => (
              <p key={i} className="text-foreground-700 text-sm md:text-base leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutInfo.stats.map((stat, i) => (
              <div key={i} className="text-center p-4 bg-background-100 rounded-xl">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">
                  {stat.number}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}